import { api, post } from "./api";

export interface UploadResult {
  file: { id: string; name: string; size: number; status: string };
  sniff: { headers: string[]; delimiter: string; encoding: string; sampleRows: Record<string, string>[] };
  suggestions: Array<{ kitId: string; entity: string; score: number }>;
  connectionId: string;
}

/** Multipart upload through the API into R2 (CON-4), with progress. */
export async function uploadCsv(workspaceId: string, file: File, onProgress?: (fraction: number) => void): Promise<UploadResult> {
  const start = await post<{ fileId: string; connectionId: string; partSize: number; parts: number }>(`/api/workspaces/${workspaceId}/files`, { name: file.name, size: file.size });
  const parts: Array<{ partNumber: number; etag: string }> = [];
  for (let i = 0; i < start.parts; i++) {
    const blob = file.slice(i * start.partSize, Math.min(file.size, (i + 1) * start.partSize));
    let lastErr: unknown;
    for (let attempt = 0; attempt < 3; attempt++) {
      try {
        const r = await api<{ partNumber: number; etag: string }>("PUT", `/api/workspaces/${workspaceId}/files/${start.fileId}/parts/${i + 1}`, blob);
        parts.push(r);
        lastErr = undefined;
        break;
      } catch (e) {
        lastErr = e;
        await new Promise((res) => setTimeout(res, 1000 * (attempt + 1)));
      }
    }
    if (lastErr) throw lastErr;
    onProgress?.((i + 1) / start.parts);
  }
  const done = await post<Omit<UploadResult, "connectionId">>(`/api/workspaces/${workspaceId}/files/${start.fileId}/complete`, { parts });
  return { ...done, connectionId: start.connectionId };
}
